export const STRIPE_MINIMUM_CARD_CHARGE = 0.5

export const BALANCE_TOPUP_MINIMUM_AMOUNT = 1000 // USD

export const MASON_USER_ID = "c0f0f363-2ca0-4bcf-85a4-2cd40576b4e1"

export const UTM_COOKIE_NAME = "supliful.utm"
export const LAST_TOUCH_COOKIE_NAME = "supliful.last_touch"
export const AD_CLICK_PARAMS = [
  "gclid",
  "wbraid",
  "gbraid",
  "fbclid",
  "li_fat_id",
  "rdt_cid",
] as const

/**
 * Set by /shopify/auth/callback
 * @see shopify.routes.ts
 */
export const QUERY_PARAM_UTM_SOURCE = "utm_source"
export const QUERY_PARAM_UTM_MEDIUM = "utm_medium"
export const QUERY_PARAM_UTM_CAMPAIGN = "utm_campaign"
export const QUERY_PARAM_STORE_TYPE = "store_type"
